import React from 'react';
import Box from '@mui/material/Box';
import UsersTable from '../../components/UsersTable/UsersTable';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import AccountApplicationTable from '../../components/AccountApplicationTable/AccountApplicationTable';

const Users: React.FC = (): React.JSX.Element => {
  const [value, setValue] = React.useState("one");

  return (
    <div style={{margin: '35px 30px 0px 30px'}}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={(_e, v) => setValue(v)}
            aria-label="app tabs"
            variant="scrollable"
          >
            <Tab label="Auth0 Users" value="one" />
            <Tab label="Account Requests" value="two" />
          </TabList>
        </Box>

        {/* Panels stay mounted; they’re only hidden when not active */}
        <TabPanel value="one" sx={{ px: 0 }}>
          <UsersTable />
        </TabPanel>
        <TabPanel value="two" sx={{ px: 0 }}>
          <AccountApplicationTable />
        </TabPanel>
      </TabContext>
    </div>
  )
};

export default Users;
